"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPresignedUrl = void 0;
const zenithApiPrivate_1 = __importDefault(require("../utils/zenithApiPrivate"));
const config_1 = __importDefault(require("../utils/config"));
const constants_1 = require("../constants");
const { zenithConfigApi } = (0, config_1.default)();
const staticModelsEndpoint = `${zenithConfigApi}${constants_1.routes.STATIC_MODELS}`;
/**
 * Axios wrapper function to update an existing application
 *
 * @param tenantId - Tenant Id for base tenant in application
 * @param objectKey: Name of the object uploaded
 */
const getPresignedUrl = (tenantId, objectKey) => {
    const url = `${staticModelsEndpoint}/${tenantId}`;
    return zenithApiPrivate_1.default.put(url, { objectKey })
        .then((res) => res);
};
exports.getPresignedUrl = getPresignedUrl;
